export const colorCode = {
  lottoGreen: '#5fc82e',
  lottoBlue: '#006ad5',
  lottoRed: '#CC1111',
  lottoWhite: '#ffffff', //dong
  lottoBlack: '#000000',
  lottoDarkGreen: '#279c4d',
  lottoGray: '#768087',
  lottoYellow: '#fbc500',
}
